import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { NotificationOptions } from '../types/notification-options';

/**
 * Notification preferences DTO
 */
@CaslSubject(AppSubjectEnum.NOTIFICATION_PREFERENCES)
export class NotificationPreferencesDto extends BaseDto {
	/**
	 * Id of the user for whom the notification preferences are defined.
	 */
	userId!: number;

	/**
	 * Flag indicating if notifications are enabled
	 * @description If false, no notifications will be sent regardless of other settings.
	 */
	enabled!: boolean;

	/**
	 * Browser specific notification options
	 * @description Holds notification options for browser notifications channel.
	 */
	browser?: NotificationOptions;

	/**
	 * Email specific notification options
	 * @description Holds notification options for email notifications channel.
	 */
	email?: NotificationOptions;

	/**
	 * Inbox specific notification options
	 * @description Holds notification options for inbox notifications channel.
	 */
	inbox?: NotificationOptions;

	/**
	 * Push specific notification options
	 * @description Holds notification options for push notifications channel.
	 */
	push?: NotificationOptions;

	/**
	 * SMS specific notification options
	 * @description Holds notification options for SMS notifications channel.
	 */
	sms?: NotificationOptions;

	/**
	 * Webhook specific notification options
	 * @description Holds notification options for webhook notifications channel.
	 */
	webhook?: NotificationOptions;
}
